import { render, staticRenderFns } from "./submission-tab-empty.vue?vue&type=template&id=c0af2392&scoped=true&"
import script from "./submission-tab-empty.vue?vue&type=script&lang=ts&"
export * from "./submission-tab-empty.vue?vue&type=script&lang=ts&"
import style0 from "./submission-tab-empty.vue?vue&type=style&index=0&id=c0af2392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af2392",
  null
  
)

export default component.exports